export function getPath(location) {
  return location.pathname.replace(/\/$/, '')
}


export function makeHash(name) {
  return name.toLowerCase().split(/\s+/).join('-')
}
